import styled from '@emotion/styled'
import { Box } from 'theme-ui'

const PaymentListStyled = styled(Box)`
  width: 100%;
`

const PaymentListItemStyled = styled.div``

export { PaymentListStyled, PaymentListItemStyled }
